import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import BaseModal from "../../components/BaseModal";
import emitter, { QUESTIONARIE_EVENTS } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import BaseButton from "../../components/BaseButton";
import useModalActions from "../../hooks/useModalActions";
import {
  SOCKET_EVENT_TYPES,
  SOCKET_EVENTS,
  SocketContext,
} from "../../components/SocketProvider";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import Game from "../../store/Game";
import ROUTES from "../../utils/routes";
import PersonalAccount from "../../store/PersonalAccount";
import useCurrentGame from "../../hooks/useCurrentGame";

const InsightFormInvitePartner = observer(({
  modalType,
  logoIcon,
  title,
  typeNotify,
}) => {
  const { t } = useTranslation();
  const { socket } = useContext(SocketContext);
  const { openModal, closeModal } = useModalActions();
  const navigate = useNavigate();
  const location = useLocation();
  const { setGame, getCurrentGame } = useCurrentGame();
  const [currentGame, setCurrentGame] = useState(null);

  const onGetInvite = ({ senderId, status, type, typeNotifyModal, gameId }) => {
    console.log('🔔 Получено insight событие:', { senderId, status, type, typeNotifyModal, gameId });
    
    // Проверяем тип события и typeNotifyModal
    if (type !== SOCKET_EVENT_TYPES.STATUS || typeNotifyModal !== typeNotify) {
      console.log('⏭️ Пропускаем событие: неподходящий тип или typeNotifyModal');
      return;
    }

    // Ищем игру по gameId
    const foundGame = PersonalAccount.games.find((game) => game.id === gameId);
    
    if (!foundGame) {
      console.log('❌ Игра не найдена:', gameId);
      return;
    }

    // Проверяем, что отправитель - это партнёр в найденной игре
    if (foundGame.partner && senderId !== foundGame.partner?.id) {
      console.log('⏭️ Пропускаем: отправитель не партнёр', { senderId, partnerId: foundGame.partner?.id });
      return;
    }

    console.log('✅ Открываем модалку для игры:', foundGame.id);
    setCurrentGame(foundGame);
    openModal(modalType);
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.INSIGHT_MESSAGE, onGetInvite);
    return () => {
      socket.current.off(SOCKET_EVENTS.INSIGHT_MESSAGE, onGetInvite);
    };
  }, [socket, typeNotify, modalType]);

  return (
    <BaseModal
      className="insight-form-invite-partner-modal"
      contentStyle="insight-form-invite-partner-modal__content"
      descriptionStyle="insight-form-invite-partner-modal__description"
      description={
        <div className="insight-form-invite-partner-modal__description-container">
          {logoIcon && logoIcon}
          {title}
        </div>
      }
      eventTypeModal={modalType}
    >
      <BaseButton
        onClick={() => {
          setGame(currentGame);
          Game.setGame(currentGame);
          if (location.pathname !== ROUTES.INSIGHT_QUESTIONNAIRE_PAGE) {
            navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE);
          }
          closeModal(modalType);
          if (location.pathname === ROUTES.INSIGHT_QUESTIONNAIRE_PAGE) {
            emitter.emit(QUESTIONARIE_EVENTS.INSIGHT_INVITED);
          }
        }}
      >
        {t("modals.insight_form_invite_partner.watch")}
      </BaseButton>
    </BaseModal>
  );
});

export default InsightFormInvitePartner;
